module.exports = __webpack_public_path__ + "img/hzhb_card.58e70513.png";